import { __assign } from "tslib";
import { FontIcon } from '@fluentui/react';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { FileType } from '@office-start/document-types';
import EdgeworthIcon from '@office-start/edgeworth-icon';
import { getFileExtensionFromFileType, getFileIconNameFromType, getFileTypeNameFromType, } from '@office-start/file-utility';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './DocumentIconControl.module.scss';
export function getDocumentIconFromType(fileType, iconSize) {
    // TODO: once Project and Portfolio svg icons are available, remove this if statement and remove the document-sprite.png resource.
    if (fileType === FileType.Portfolio) {
        return "document-icon-sprite document-icon-sprite-".concat(getFileIconNameFromType(fileType).toLowerCase(), "-").concat(iconSize);
    }
    return "document-icon--".concat(iconSize, " document-icon--").concat(getFileIconNameFromType(fileType).toLowerCase());
}
function iconSizeToNumber(iconSize) {
    switch (iconSize) {
        case '16x16':
            return 16;
        case '20x20':
            return 20;
        case '24x24':
            return 24;
        case '32x32':
            return 32;
        case '64x64':
            return 64;
    }
}
export var DocumentIconControl = function (_a) {
    var _b;
    var item = _a.item, iconSize = _a.iconSize, hideBackground = _a.hideBackground, customIconAltText = _a.customIconAltText;
    var extensionOverride = useMemo(function () {
        var _a;
        return !item.extension && item.fileType
            ? (_a = getFileExtensionFromFileType(item.fileType)) !== null && _a !== void 0 ? _a : ''
            : '';
    }, [item.extension, item.fileType]);
    var title = getFileTypeNameFromType(item.fileType);
    return (React.createElement("div", { title: title }, item.fileType === FileType.MeetingObject ? (React.createElement("div", { className: !hideBackground
            ? styles['meeting-object-icon__wrapper']
            : '' },
        React.createElement("div", { className: classNames(styles['meeting-object-icon'], (_b = {},
                _b[styles['meeting-object-icon--no-background']] = hideBackground,
                _b)) },
            React.createElement(EdgeworthIcon, { iconName: "CalendarIcon" })))) : item.iconUrl ? (React.createElement("img", { className: classNames(styles["custom-icon--".concat(iconSize)], styles['custom-icon']), src: item.iconUrl, alt: customIconAltText })) : item.fileType === FileType.Stream ||
        item.fileType === FileType.Project ||
        item.fileType === FileType.Forms ||
        item.fileType === FileType.Sway ||
        item.fileType === FileType.PlayLists ||
        item.fileType === FileType.PlayList ||
        item.fileType === FileType.Portfolio ||
        item.fileType === FileType.Designer ||
        item.fileType === FileType.List ||
        item.fileType === FileType.Clipchamp ||
        item.fileType === FileType.Draft ? (React.createElement("span", { className: classNames(getDocumentIconFromType(item.fileType, iconSize), styles['document-list-item__icon--display']) })) : (React.createElement(React.Fragment, null,
        React.createElement(FontIcon, __assign({}, getFileTypeIconProps({
            size: iconSizeToNumber(iconSize),
            extension: item.extension || extensionOverride,
            imageFileType: 'svg',
        }), { "aria-label": title }))))));
};
//# sourceMappingURL=DocumentIconControl.js.map